import { BitkitSpinner } from '@bitrise/bitkit-v2';

const MessageFetching = () => {
  return (
    <BitkitSpinner
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      color="icon/tertiary"
      role="status"
      aria-label="Loading"
    />
  );
};

export default MessageFetching;
